__turbopack_context__.v({
  "content": "bPVRYa_content",
  "grid": "bPVRYa_grid",
  "header": "bPVRYa_header",
  "left": "bPVRYa_left",
  "right": "bPVRYa_right",
});
